import supt from '@/utils/supt'
export default {
  state: {
    // 加载状态
    loaded: false,
    // 用户信息
    info: {},
    // 当前父菜单
    pmenuId: '0',
    // 当前活动菜单
    activeMenu: null,
    // 全部菜单
    menus: [],
    // 父菜单
    pJmenus: {},
    // 扩展菜单
    extMenus: [],
    // 树形菜单
    treeMenus: [],
    // 许可集
    permissions: [],
    // 面包屑
    breadCrumbs: {}
  },
  getters: {
    userLoaded(state) {
      return state.loaded
    },
    menus(state) {
      return state.menus
    },
    extMenus(state) {
      return state.extMenus
    },
    getMenuById: (state) => (id) => {
      return _.find(state.extMenus, { menuId: String(id) }) || _.find(state.menus, { menuId: Number(id) })
    },
    getMenuByPath: (state) => (path) => {
      return _.find(state.extMenus, { menuUrl: path }) || _.find(state.menus, { menuUrl: path })
    },
    getPMenuIdById: (state) => (id) => {
      if (!state.pJmenus[id]) {
        let buildPmenu = (aid) => {
          // 当前菜单
          let currentMenu = _.find(state.menus, o => o.menuId == aid)
          return !!_.get(currentMenu, 'pmenuId') ? buildPmenu(currentMenu.pmenuId) : _.get(currentMenu, 'menuId', '0')
        }
        state.pJmenus[id] = buildPmenu(id)
      }
      return state.pJmenus[id]
    },
    treeMenus(state) {
      return state.treeMenus
    },
    // 通过主键获取面包屑内容
    getBreadCrumbs: (state) => {
      if (!state.breadCrumbs[state.activeMenu]) {
        // 面包屑构建
        let crumbsBuilder = (aid, crumbs = []) => {
          // 当前面包屑
          let currentMenu = _.find(state.menus, o => o.menuId == aid)
          // 当前存放入面包屑
          !!currentMenu && crumbs.push(currentMenu.menuName) && !!currentMenu.pmenuId && crumbsBuilder(currentMenu.pmenuId, crumbs)
          // 返回面包屑
          return crumbs
        }
        // 处理面包屑
        state.breadCrumbs[state.activeMenu] = _.reverse(crumbsBuilder(state.activeMenu))
      }
      return state.breadCrumbs[state.activeMenu]
    }
  },
  mutations: {
    // 设置用户信息
    setUserInfo(state, info) {
      // 设置用户全信息
      state.info = info
      // 常用数据处理
      let { menus, realName } = info
      // 设置全菜单
      state.menus = _.filter(menus, { menuType: 1 })
      // 普通菜单转树菜单
      state.treeMenus = supt.array2tree(state.menus, 'menuId', 'pmenuId', 'children', (item) => {
        item.menuId = String(item.menuId)
      })
      // 默认首菜单
      state.menuId = (state.treeMenus[0] || {}).menuId
      // 设置许可集
      state.permissions = _.map(_.filter(menus, { menuType: 0 }), 'menuTarget')
      // 用户加载状态
      state.loaded = true
    },
    // 扩展菜单
    setUserExtMenus(state, extMenus) {
      state.extMenus = extMenus
    },
    // 设置当前父菜单
    setUserPmenu(state, menuId) {
      state.pmenuId = menuId
    },
    setUserActiveMenu(state, menuId) {
      state.activeMenu = menuId
    },
    setUserLoaded(state, loaded) {
      state.loaded = loaded
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js